import React, { useEffect } from 'react';
import { Box, Stack } from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';
import MainCard from 'components/MainCard';
import MarketTrendsInput from 'sections/market-trends/MarketTrendsInput';
import MarketTrends from 'sections/lp-analysis/MarketTrends';
import BlockedInput from 'sections/askPage/BlockedInput';
import FetchPlanInfo from 'services/proAccountServices';

const MarketTrendsPage = () => {
  const { marketTrends } = useSelector((state) => state.marketTrendsReducer);
  const { loadingAnswer } = useSelector((state) => state.loadingReducer);
  const dispatch = useDispatch();

  useEffect(() => {
    FetchPlanInfo(dispatch);
  }, [dispatch]);

  // Create a properly structured object for the MarketTrends component
  const formattedMarketTrends = marketTrends
    ? {
        trends: marketTrends.market_trends?.trends || [],
        benchmarks: marketTrends.market_trends?.benchmarks || [],
        industry: marketTrends.market_trends?.industry || ''
      }
    : null;

  return (
    <MainCard
      style={{ position: 'relative', display: 'flex', flexDirection: 'column', flexGrow: 1, border: 0, p: 0 }}
      xs={12}
      sx={{
        width: '100%',
        bottom: 0
      }}
    >
      <Stack direction="column" spacing={2} alignItems="center">
        <Box
          mb={0}
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: !marketTrends ? '50vh' : '10vh',
            width: '100%'
          }}
        >
          <MarketTrendsInput />
        </Box>
      </Stack>
      {loadingAnswer && (
        <Box sx={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
          <BlockedInput text="Searching for relevant trends..." />
        </Box>
      )}
      <Box pt={loadingAnswer ? 2 : 6.7} sx={{ display: 'flex', justifyContent: 'center' }}>
        {marketTrends && !loadingAnswer && <MarketTrends marketTrends={formattedMarketTrends} />}
      </Box>
    </MainCard>
  );
};

export default MarketTrendsPage;
